import { createRouter, createWebHistory } from 'vue-router'
import { Route } from '@/router/types'
import { adminRoutes } from './routes/admin'
import { patientRoutes } from './routes/patient'
import { patientMgmtRoutes } from './routes/patientMgmt'
import { queueRoutes } from './routes/queues'
import { toolRoutes } from './routes/tools'

export const routes: Route[] = [
  // Routes without auth
  {
    path: '/',
    name: '#home',
    redirect: '/my-queue',
    meta: {
      title: '',
      unauthenticated: true,
    },
  },
  {
    path: '/error',
    name: '#error',
    component: () => import('@/pages/Basic/ErrorPage/ErrorPage.vue'),
    meta: {
      title: 'Error',
      unauthenticated: true,
    },
  },
  {
    path: '/auth/callback',
    name: '#authCallback',
    component: () => import('@/pages/Basic/AuthCallback/AuthCallback.vue'),
    meta: {
      title: 'Authenticating...',
      // The auth callback page needs to be public
      // https://github.com/auth0/auth0-vue/blob/main/FAQ.md#4-getting-an-infinite-redirect-loop-between-my-application-and-auth0
      unauthenticated: true,
    },
  },
  // All other routes require auth and will redirect to auth0 if not authenticated
  ...patientRoutes,
  ...patientMgmtRoutes,
  ...queueRoutes,
  ...toolRoutes,
  ...adminRoutes,
  {
    path: '/:pathMatch(.*)*',
    name: '#notFound',
    component: () => import('@/pages/Basic/NotFound/NotFound.vue'),
    meta: {
      title: 'Page Not Found',
      permissionCheck: null,
    },
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  linkActiveClass: 'is-active',
  routes,
})

export default router
